// Ortak — çekmecenin TEK bilgi ızgarası: Telefon | E-posta, sonra T.C. (verilirse), sonra `extra`
// hücreleri (ör. aktivasyon tarihi). Değerler düz metindir — maskeli olsun olmasın ASLA
// `mailto:`/`tel:` bağlantısı değil. Sunucu-maskeli T.C. yalnız gösterilir (Göster/Gizle yok,
// `TcKimlikValue`'ya verilmez); düz 11 hane olmayan bir T.C. de bayraktan bağımsız maskeli sayılır
// (`isServerMaskedTc`, fail closed).
import { type ReactNode, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { PersonnelMaskNotice } from './PersonnelMaskNotice';
import { TcKimlikValue } from './TcKimlikValue';
import { isServerMaskedTc } from './tcKimlik';

export interface PersonnelFactsProps {
  email: string | null | undefined;
  phone: string | null | undefined;
  personalDataMasked: boolean;
  /** İzin çekmecesi gibi T.C. göstermemesi gereken yüzeylerde verilmez. */
  tc?: { value: string | null | undefined; labelId: string };
  /** Ek ızgara hücreleri (`<div><dt/><dd/></div>`) — aynı ızgarada tek ızgara olarak çıkar. */
  extra?: ReactNode;
}

const DD = 'mt-0.5 min-w-0 break-words text-sm text-fg [overflow-wrap:anywhere]';

export function PersonnelFacts({
  email,
  phone,
  personalDataMasked,
  tc,
  extra,
}: PersonnelFactsProps) {
  const { t } = useTranslation();
  const tcValue = tc?.value;
  const masked = personalDataMasked || isServerMaskedTc(tcValue);
  return (
    <div className="space-y-2">
      <dl className="grid grid-cols-1 gap-4 sm:grid-cols-2">
        <div className="min-w-0">
          <dt className="text-xs font-medium text-muted">{t('personnelForm.field.phone')}</dt>
          <dd className={DD}>{phone ?? '—'}</dd>
        </div>
        <div className="min-w-0">
          <dt className="text-xs font-medium text-muted">{t('personnelForm.field.email')}</dt>
          <dd className={DD}>{email ?? '—'}</dd>
        </div>
        {tc && (
          <div className="min-w-0">
            <dt id={tc.labelId} className="text-xs font-medium text-muted">
              {t('personnelForm.field.tcKimlikNo')}
            </dt>
            <dd className={DD}>
              {tcValue == null ? (
                '—'
              ) : masked ? (
                <span className="tabular-nums">{tcValue}</span>
              ) : (
                <RevealableTc key={tcValue} value={tcValue} labelId={tc.labelId} />
              )}
            </dd>
          </div>
        )}
        {extra}
      </dl>
      {masked && <PersonnelMaskNotice />}
    </div>
  );
}

/**
 * Göster/Gizle durumu T.C. DEĞERİNE bağlı (`key`): çekmece açıkken kişi değişirse bir sonraki kişinin
 * T.C.'si tıklanmadan asla açık görünmez.
 */
function RevealableTc({ value, labelId }: { value: string; labelId: string }) {
  const [revealed, setRevealed] = useState(false);
  return (
    <TcKimlikValue
      tcKimlikNo={value}
      revealed={revealed}
      onToggle={() => setRevealed((r) => !r)}
      describedBy={labelId}
    />
  );
}
